import React from 'react';
import {isNullOrUndefined} from "../../utils";


interface ButtonIconInterface {
    icon: string;
    solid?: boolean;
    tooltip?: string;
    mask?: string;
    shrink?: number;
    color: string;
    size?: string;
}

const ButtonIcon: React.FC<ButtonIconInterface> = (props) => {
    const {icon, mask, shrink, solid, color, size} = props;
    const bmask = (isNullOrUndefined(mask) ? 'fa-circle' : mask);
    const bshrink = (isNullOrUndefined(shrink) ? 5.5 : shrink);
    const bsolid = (isNullOrUndefined(solid) ? 'fal' : (solid ? 'fas' : 'fal'));
    const bsize = (isNullOrUndefined(size) ? '1.8rem' : size);
    const dataTransform = `shrink-${bshrink}`;
    const dataMask = `fas ${bmask}`;
    const bClassName = `${bsolid} ${icon}`;
    return (
        <span style={{fontSize: bsize, color: `${color}`}}>
            <i
                className={bClassName}
                data-fa-transform={dataTransform}
                data-fa-mask={dataMask}
            />
        </span>
    );
};

export default ButtonIcon;